import get from 'lodash.get';

export const ANSWER_FETCH_SUCCESS = 'knowledge_base/ANSWER_FETCH_SUCCESS';
export const ANSWER_UPDATE_SEARCH_RESULTS = 'knowledge_base/ANSWER_UPDATE_SEARCH_RESULTS';
export const ANSWER_UPDATE_SELECTED_ANSWER = 'knowledge_base/ANSWER_UPDATE_SELECTED_ANSWER';
export const ANSWER_CLEAR_SEARCH_RESULTS = 'knowledge_base/ANSWER_CLEAR_SEARCH_RESULTS';

export const kbEventTypes = {
  ANSWER_FETCH_SUCCESS,
  ANSWER_UPDATE_SEARCH_RESULTS,
  ANSWER_UPDATE_SELECTED_ANSWER,
  ANSWER_CLEAR_SEARCH_RESULTS,
};

export function fetchAnswersSuccess({ answers = [], suggestedAnswerIds }) {
  return {
    type: ANSWER_FETCH_SUCCESS,
    payload: {
      answers: answers.filter(answer => get(answer, 'content.public')), // filter by public answers
      suggestedAnswerIds,
    },
  };
}

export function updateKBSearchResults({ searchResultAnswerIds }) {
  return {
    type: ANSWER_UPDATE_SEARCH_RESULTS,
    payload: { searchResultAnswerIds },
  };
}

export function updateSelectedAnswer({ selectedResultAnswerId }) {
  return {
    type: ANSWER_UPDATE_SELECTED_ANSWER,
    payload: { selectedResultAnswerId },
  };
}

export function clearKBSearchResults() {
  return {
    type: ANSWER_CLEAR_SEARCH_RESULTS,
  };
}

export default {
  fetchAnswersSuccess,
  updateKBSearchResults,
  updateSelectedAnswer,
  clearKBSearchResults,
};
